import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialData = {
  balanceNamesData: {},
  dropDownData: {},
  balanceNamesStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'balanceNames',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchBalanceNamesData: (state, action) => {
      state.balanceNamesData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postBalanceNamesData: (state, action) => {
      state.balanceNamesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },

    resetBalanceNames: (state) => {
      state.balanceNamesStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchBalanceNamesData,
  postBalanceNamesData,
  resetMsg,
  resetBalanceNames,
  fetchError,
} = slice.actions;
export const fetchBalanceNames = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/debtorbalancenames/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchBalanceNamesData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postBalanceNames = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/debtorbalancenames`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postBalanceNamesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetBalanceNames());
  };
};
